import { HTTPInterceptor } from 'src/support/network/http_interceptor';
import { IModuleConfiguration, ModuleConfiguration } from 'src/types/system_types';
import { IFetchResponse } from '../types/hip_types';
import { getActiveRoute } from 'src/core/settings';

import navigation from'../../../pip/library/pi-navigation/pi-navigation.js';
import tt from'../../../pip/library/pi-tt/pi-tt.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';
import ess from'../../../pip/library/pi-ess/pi-ess.js';

export interface IAuthenticationModuleConfiguration extends IModuleConfiguration {
  unauthenticated: {
    error_key: string;
    status_codes: number[];
  };
  features: {
    unauthenticate_in_client: boolean;
    unauthenticate_http_response: boolean;
  };
}

const lens = {
  unauthenticatedRoutes: '/navigation/paths/routes/unauthenticated',
  nth1: '/1'
};

export class AuthenticationModule extends ModuleConfiguration {
  configuration: IAuthenticationModuleConfiguration;

  /**
   *
   * @param configuration
   */
  initialize(configuration: IAuthenticationModuleConfiguration) {
    return new Promise((resolve) => {
      this.configuration = this.__defaultConfiguration(configuration);

      if (this.configuration.features.unauthenticate_in_client) {
        this.__listenEvent_authenticationVerification();
      }
      if (this.configuration.features.unauthenticate_http_response) {
        this.__trackEvent_authenticationVerification();
      }

      resolve(this.configuration);
    });
  }

  private __defaultConfiguration(configuration: IAuthenticationModuleConfiguration) {
    return tt.mergeWith(
      'clobber',
      {
        unauthenticated: {
          error_key: 'metadata.errors',
          status_codes: [401, 402, 407, 451]
        },
        features: {
          unauthenticate_in_client: true,
          unauthenticate_http_response: true
        }
      },
      configuration
    ) as IAuthenticationModuleConfiguration;
  }

  private __trackEvent_authenticationVerification() {
    HTTPInterceptor.instance.errorHTTP.push({
      statusCode: this.configuration.unauthenticated.status_codes,
      fn: <T>(uri: string, response: IFetchResponse, payload: T, htmlEl: HTMLElement) => {
        ess.failure({
          ns: 'ahp',
          site: 'security',
          action: 'authenticated',
          source: uri,
          data: tt.get(this.configuration.unauthenticated.error_key, htmlEl)
        });

        return payload;
      }
    });
  }

  private __listenEvent_authenticationVerification() {
    ess.on(
      {
        ns: 'ahp',
        site: 'security',
        status: 'failure',
        action: 'authenticated'
      },
      () => {
        ess.trap({
          ns: 'ahp',
          site: 'session',
          source: 'account',
          action: 'clear'
        });

        const unauthenticatedRoute = f1.read(lens.unauthenticatedRoutes, '', this.ahp.configuration._);
        const activeRoute = getActiveRoute();

        if (unauthenticatedRoute !== activeRoute) {
          const activeParams = f1.read(lens.nth1, null, location.href.split('?'));
          const uri = activeParams ? `${unauthenticatedRoute}?${activeParams}` : unauthenticatedRoute;

          navigation.goTo(`#/${uri}`);
        }
      }
    );
  }
}
